// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PVerticalAlignMiddlOutlinedSvg from "@fishx/icons-svg/es/asn/PVerticalAlignMiddlOutlined";
import FishxIcon from '../components/FishxIcon';

var PVerticalAlignMiddlOutlined = function PVerticalAlignMiddlOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PVerticalAlignMiddlOutlinedSvg
  }));
};

PVerticalAlignMiddlOutlined.displayName = 'PVerticalAlignMiddlOutlined';
export default React.forwardRef(PVerticalAlignMiddlOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PVerticalAlignMiddlOutlined.js
// module id = 3724
// module chunks = 0